<div class="header">
  <nav class="navbar-default navbar navbar-expand-lg"
       [ngClass]=" {'rounded-top-5': !isMobileMenuClosed && isMobile, 'shadow-none' : isMobile}">

    <a id="nav-toggle" *ngIf="isMobile && !isFilterPage" (click)="mobileMenuCloseAndOpen()" class="cursor-pointer">
      <img src="./assets/images/svg/hamburger.svg" alt="hamburger">
    </a>
    <a id="prev-page" *ngIf="isMobile && isFilterPage" (click)="prevPage()" class="cursor-pointer fs-2 text-gray">
      &lt;
    </a>

    <div *ngIf="isMobile" class="fs-4 lh-base">
      {{ pageTitle }}
    </div>

    <!-- Desktop Buttons -->
    <div class="ms-auto d-flex align-items-center mr-3" *ngIf="!isMobile">
      <button class="btn btn-primary rounded-5 mr-2" (click)="openQuizGenerationModal()">Generate with AI</button>
      <button class="btn btn-primary rounded-5" (click)="navigateToQuizCreation()">Create New Test</button>
    </div>

    <div class="profile-image-container" (click)="logout()">
      <div class="profile-image">
        <img src="https://www.arabiantourpackages.com/assets/images/tours/gallery/img-world-dubai-tickets.jpeg"
             alt="Profile" class="img-fluid rounded-circle">
      </div>
    </div>
  </nav>
</div>
